import {
  Box,
  Button,
  Fade,
  Grid,
  Modal,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";

const formatDateForInput = (dateStr) => {
  if (!dateStr) return "";
  const parsed = dayjs(dateStr, [
    "DD/MM/YYYY",
    "YYYY-MM-DD",
    "D/M/YYYY",
    dayjs.ISO_8601,
  ]);
  return parsed.isValid() ? parsed.format("YYYY-MM-DD") : "";
};

const EditTeamModal = ({ open, onClose, inputForm, handleInputChange, onSubmit }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Fade in={open} timeout={500}>
        <Box
          sx={{
            bgcolor: "background.paper",
            boxShadow: 24,
            borderRadius: 2,
            width: { xs: "90%", sm: "80%", md: "60%" },
            maxHeight: "90vh",
            overflowY: "auto",
            px: 4,
            py: 3,
          }}
        >
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="subtitle" sx={{ mb: 2, }}>
              Edit Team Information
            </Typography>

            <Stack direction="row" spacing={2}>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "secondary.main",
                  fontWeight: "bold",
                  "&:hover": { backgroundColor: "secondary.dark" },
                }}
                onClick={() => onSubmit()}
              >
                Save
              </Button>
            </Stack>
          </Box>

          <Grid container spacing={2}>
            <Grid item size={{ xs: 12, sm: 6 }}>
              <Typography variant="body" sx={{ mb: 0.5 }}>Name</Typography>
              <TextField
                fullWidth
                size="small"
                value={inputForm.name || ""}
                onChange={(e) => handleInputChange("name", e)}
              />
            </Grid>

            <Grid item size={{ xs: 12, sm: 6 }}>
              <Typography variant="body" sx={{ mb: 0.5 }}>Point</Typography>
              <TextField
                fullWidth
                size="small"
                type="number"
                value={inputForm.teamPoint || "0"}
                onChange={(e) => handleInputChange("teamPoint", e)}
              />
            </Grid>

            <Grid item size={{ xs: 12, sm: 6 }}>
              <Typography variant="body" sx={{ mb: 0.5 }}>Start Date</Typography>
              <TextField
                fullWidth
                type="date"
                size="small"
                value={formatDateForInput(inputForm.startDate)}
                onChange={(e) => handleInputChange("startDate", e)}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item size={{ xs: 12, sm: 6 }}>
              <Typography variant="body" sx={{ mb: 0.5 }}>End Date</Typography>
              <TextField
                fullWidth
                type="date"
                size="small"
                value={formatDateForInput(inputForm.endDate)}
                onChange={(e) => handleInputChange("endDate", e)}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
          </Grid>
        </Box>
      </Fade>
    </Modal>
  );
};

export default EditTeamModal;
